var app = angular.module("leonardo");

var OwnerTemplatesStates = function($stateProvider) {
  $stateProvider.state('owner-tasks.templates', {
    url: "/templates",
    title: 'Templates',
    cssClass: 'page-template-list',
    templateMode: 'owner',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/template/list.html',
        controller: 'TemplateList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/template-list.html',
        controller: 'TemplateListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'TemplateListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Templates'
    }
  });

  $stateProvider.state('owner-tasks.templates.edit', {
    url: "/:pk/edit",
    title: 'Template edit',
    params: {
      pk: '',
      squash: false
    },
    cssClass: 'page-template-edit',
    templateMode: 'owner',
    views: {
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form.html'
      }
    },
    resolve: {
      templateObj: ['TemplateService', '$stateParams', function(TemplateService, $stateParams) {
        return TemplateService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Template edit'
    }
  });

  $stateProvider.state('owner-tasks.templates.add', {
    url: "/add?origin&account",
    title: 'Add Template',
    cssClass: 'page-template-edit',
    templateMode: 'owner',
    action: 'create',
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form.html'
      }
    },
    resolve: {
      templateObj: ['TemplateService', 'AccountService', 'AccountUserService', function(TemplateService, AccountService, AccountUserService) {
        if (AccountUserService.currentAccountUser) {
          return TemplateService.bulkObject(AccountUserService.currentAccountUser.account);
        }
        else {
          return TemplateService.bulkObject(null);
        }
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Template'
    }
  });
};

app.config(['$stateProvider', OwnerTemplatesStates]);
